export default {
  White: '#FFFFFF',
  Black: '#000000',
  Gray23: '#3B3B3B',
  Brass: '#B99A44',
  ShadowLight: '#D1D3D6',
}
